import createReactComponent from '../createReactComponent';
var Coins = createReactComponent('Coins', [['circle', {
  cx: '8',
  cy: '8',
  r: '7',
  key: '1ypuc1'
}], ['path', {
  d: 'M19.5 9.94a7 7 0 11-9.56 9.56',
  key: '13a5o5'
}], ['path', {
  d: 'M7 6h1v4',
  key: '1obek4'
}], ['path', {
  d: 'M17.3 14.3l.7.7-2.8 2.8',
  key: '1qgf5j'
}]]);
export default Coins;